module.exports = __webpack_public_path__ + "img/yilianGl15.2187a6fe.png";